/**
 * Authentication utilities for Safari/iOS compatibility.
 * Stores session token in localStorage as fallback when cookies don't work.
 */

const TOKEN_KEY = 'expenseflow_session_token';

export const authUtils = {
  /**
   * Store the session token (called after login/OTP verification)
   */
  setToken: (token) => {
    if (token) {
      localStorage.setItem(TOKEN_KEY, token);
      console.log('[Auth] Token stored in localStorage');
    }
  },

  /**
   * Get the stored session token
   */
  getToken: () => {
    return localStorage.getItem(TOKEN_KEY);
  },

  /**
   * Clear the stored session token (called on logout)
   */
  clearToken: () => {
    localStorage.removeItem(TOKEN_KEY);
    console.log('[Auth] Token cleared from localStorage');
  },

  /**
   * Get authorization headers for API requests
   */
  getAuthHeaders: () => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) {
      return { Authorization: `Bearer ${token}` };
    }
    return {};
  },

  /**
   * Check if we have a stored token
   */
  hasToken: () => {
    return !!localStorage.getItem(TOKEN_KEY);
  }
};

export default authUtils;
